// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"
import { default_option } from "pages/Purchase/utils"

interface PaymentVendorType {
  bill_id: number
  trx_code: string
  transaction_date: string
  bill_status: string
  ref_bill_id: string
  memo: string
  deposit_amount: number
  payment_amount: number
  approve_status: number
}

export function usePaymentVendorList(purchase_order_id: string): {
  data: PaymentVendorType[]
  isLoading: boolean
} {
  // Vars
  const defaultData: PaymentVendorType[] = []

  // Hooks
  const api = useApi()
  const [data, setData] = useState<PaymentVendorType[]>(defaultData)
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    const promise = new Promise<PaymentVendorType[]>((resolve) => {
      setLoading(true)

      api.get("/depositvendor/payment_deposit_by_po", {
        params: { purchase_order_id }
      }).then((res: SuccessFetch<{ payload: {
        ref_bill_id: string
        deposit_amount: string
        payment_amount: string
        bill_id: number
        trx_code: string
        transaction_date: string
        bill_status: number
        memo: string
        approve_status: number
      }[] }>) => {
        resolve(res.data.payload.map(item => {
          return {
            bill_id: item.bill_id,
            bill_status: default_option.find(i => i.value === item.bill_status.toString())?.label ?? "-",
            deposit_amount: parseInt(item.deposit_amount),
            payment_amount: parseInt(item.payment_amount),
            memo: item.memo,
            ref_bill_id: item.ref_bill_id,
            transaction_date: item.transaction_date,
            trx_code: item.trx_code,
            approve_status: item.approve_status
          }
        }))
      }).catch(() => {
        resolve(defaultData)
      }).finally(() => {
        setLoading(false)
      })
    })

    promise.then(setData)

    return () => {
      setData(defaultData)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}